// frontend/src/components/chatbot/ChatbotButton.jsx
import React from 'react';
import { MessageCircle } from 'lucide-react';
import useChatbot from './useChatbot';

const ChatbotButton = () => {
  const { isOpen, toggleOpen } = useChatbot();

  return (
    <button
      type="button"
      onClick={toggleOpen}
      className="chatbot-float-button"
      aria-label={isOpen ? 'Close support chat' : 'Open support chat'}
      title="App Assistant"
    >
      <MessageCircle size={24} />
    </button>
  );
};

export default ChatbotButton;
